/* @flow */
import * as React from 'react';
import Glyph from 'components/Glyph';
import './styles/LinkedAccountFailureView.scss';

type Props = {
  location: Object,
};

class LinkedAccountFailureView extends React.Component<Props> {
  componentDidMount() {
    const { location } = this.props;
    const { strategy, message } = location.query;
    // If it's an unexpected error, log it to rollbar
    //   access_denied -> They said no when they were asked to link to Remind
    if (strategy && message && message !== 'access_denied') {
      console.error(`Failed to link account for provider ${strategy}: ${message}`);
    }
  }

  render() {
    return (
      <div className="LinkedAccountFailureView">
        <div className="LinkedAccountFailureView-wrap">
          <Glyph className="LinkedAccountFailureView-link" name="link" size="xxlarge" />
          <div className="LinkedAccountFailureView-title">{'Failed to link account'}</div>
          <div className="LinkedAccountFailureView-body">{'Please try again later'}</div>
        </div>
      </div>
    );
  }
}

export default LinkedAccountFailureView;
